/**
 * @description   Types is just for constant that for dispatching our action in order to reducing a Misspelling
 */

export const SET_COLLECTION = "SET_COLLECTION"